import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X, Crown } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  product: string;
  timeAgo: string;
}
const PREMIUM_PRODUCT = 'Kit Aula de Éxitos + COMPLETO';
const purchases: Purchase[] = [{
  name: 'Mariela G.',
  location: 'Montevideo',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Laura P.',
  location: 'Canelones',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 7 minutos'
}, {
  name: 'Rosa M.',
  location: 'Salto',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 11 minutos'
}, {
  name: 'Sofía C.',
  location: 'Montevideo',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 14 minutos'
}, {
  name: 'Patricia A.',
  location: 'Rivera',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 18 minutos'
}, {
  name: 'Cecilia R.',
  location: 'Canelones',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 22 minutos'
}, {
  name: 'Valeria T.',
  location: 'Maldonado',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 26 minutos'
}, {
  name: 'Andrea S.',
  location: 'Paysandú',
  product: PREMIUM_PRODUCT,
  timeAgo: 'hace 31 minutos'
}];
const VISIBLE_MS = 5000;
const HIDDEN_MS = 7000;
const FIRST_DELAY_MS = 4000;
export const PurchaseNotifications = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: ReturnType<typeof setTimeout>;
    const showNext = () => {
      setVisible(true);
      timeoutId = setTimeout(() => {
        setVisible(false);
        timeoutId = setTimeout(() => {
          setIndex(prev => (prev + 1) % purchases.length);
          showNext();
        }, HIDDEN_MS);
      }, VISIBLE_MS);
    };
    const startId = setTimeout(showNext, FIRST_DELAY_MS);
    return () => {
      clearTimeout(startId);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissed]);
  if (dismissed) return null;
  const current = purchases[index];
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] sm:max-w-sm" aria-live="polite" data-id="element-325">
      <AnimatePresence mode="wait" data-id="element-326">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="flex items-start gap-3 bg-white rounded-2xl shadow-xl border border-stone-100 p-4 pr-9 relative" data-id="element-327">
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-stone-300 hover:text-stone-500 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-celeste-500 rounded" data-id="element-328">
              <X className="w-4 h-4" data-id="element-329" />
            </button>

            <div className="relative shrink-0" data-id="element-330">
              <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center font-bold text-sm" data-id="element-331">
                {current.name.split(' ').map(n => n[0]).join('')}
              </div>
              <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-amber-400 text-stone-900 flex items-center justify-center shadow-sm" data-id="element-332">
                <Crown className="w-3 h-3" data-id="element-333" />
              </span>
            </div>

            <div className="min-w-0" data-id="element-334">
              <p className="text-sm text-stone-800 font-bold leading-snug" data-id="element-335">
                {current.name} de {current.location}
              </p>
              <p className="text-sm text-stone-600 leading-snug" data-id="element-336">
                acaba de comprar el{' '}
                <span className="font-semibold text-stone-800" data-id="element-337">
                  {current.product}
                </span>
              </p>
              <p className="flex items-center gap-1 text-xs text-emerald-600 font-semibold mt-1" data-id="element-338">
                <BadgeCheck className="w-3.5 h-3.5" data-id="element-339" />
                Compra verificada · {current.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};